"use client";

import { useRouter } from "next/navigation";

export default function NotFound() {
  const router = useRouter();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-100 text-center dark:bg-gray-900">
      <div className="max-w-md rounded-lg bg-white p-8 shadow-lg dark:bg-gray-800">
        <h1 className="mb-4 text-6xl font-bold text-blue-600 dark:text-blue-400">
          404
        </h1>
        <h2 className="mb-2 text-2xl font-semibold text-gray-800 dark:text-gray-200">
          페이지 준비중입니다.
        </h2>
        <p className="mb-6 text-gray-600 dark:text-gray-400">
          요청하신 페이지는 현재 준비중에 있습니다. <br />
          빠른 시일 내에 좋은 모습으로 찾아뵙겠습니다.
        </p>
        <button
          onClick={() => router.back()}
          className="inline-block rounded-md bg-blue-600 px-6 py-3 text-sm font-medium text-white transition-colors hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800"
        >
          이전 페이지로 돌아가기
        </button>
      </div>
    </div>
  );
}
